import styled, { createGlobalStyle } from 'styled-components';
import { animated } from '@react-spring/web';
import { ResponsiveWidth } from '../../../../components/Css';
import { motion } from 'framer-motion';

const animation = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: {
    duration: 0.5,
    ease: 'easeOut',
  },
};

export const OverlayContainer = styled(animated.div)`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-content: center;

  z-index: 1000;

  @media (min-width: ${ResponsiveWidth}px) {
    display: flex;
    align-items: center;

    height: 100%;
    width: 100%;
    min-width: 400px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-regular);
  color: var(--colorTextPrimary);
  height: auto;
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
`;

export const LogoContainer = styled.div`
  cursor: pointer;
`;

export const Content = styled(motion.div).attrs(() => animation)`
  height: 100%;
  margin-top: var(--spacing-regular);

  border-radius: var(--borderRadiusBase) var(--borderRadiusBase) 0px 0px;
  background-color: var(--colorBgContainer);
  color: var(--colorBgTextContainer);
  width: calc(100% - var(--spacing-big) - var(--spacing-big));
  padding: var(--spacing-regular) var(--spacing-big);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${ResponsiveWidth}px) {
    border-radius: var(--borderRadiusBase);
    max-width: ${ResponsiveWidth}px;
    padding: 32px;

    display: flex;
    justify-content: center;
    align-items: start;
    height: auto;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const NavigationContainer = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin-top: ${(props) => (props.$isMobile ? 'var(--spacing-regular)' : '0')};
  margin-bottom: var(--spacing-regular);

  font-size: var(--font-medium);

  color: var(--color-container-icon);

  cursor: pointer;

  @media (max-width: 1280px) {
    margin-bottom: var(--spacing-small);
  }
`;

export const TitleWrapper = styled.div<{ $customStyles?: any }>`
  display: flex;
  margin-bottom: var(--spacing-regular);
  width: 100%;
  margin-top: var(--spacing-regular);

  width: 100%;
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-medium);

  color: var(--color-text);

  font-size: var(--font-medium);
  font-family: var(--font-family-bold);

  @media (min-width: ${ResponsiveWidth}px) {
    font-size: var(--font-big);
    font-weight: bold;

    ${(props) =>
      props.$customStyles &&
      `
        margin-bottom: ${
          props.$customStyles.marginBottom || 'var(--spacing-regular)'
        } !important;
        margin-top: ${
          props.$customStyles.marginTop || 'var(--spacing-regular)'
        } !important;
        font-size: ${
          props.$customStyles.fontSize || 'var(--font-giant)'
        } !important;
        color: ${
          props.$customStyles.color || 'var(--color-text)'
        } !important;
        font-weight: ${props.$customStyles.fontWeight || 'bold'} !important;
    `}
  }
`;

export const ChildrenWrapper = styled.div`
  flex: 1;
`;

export const FooterDivContainer = styled.div<{ $isMobile?: boolean }>`
  width: calc(100%);
  display: flex;
  justify-content: flex-end;
  margin-top: auto; /* Empurra para o final do container flexível */
  padding: ${(props) => (props.$isMobile ? 'var(--spacing-regular)' : '0')};
`;

export const TitleFmlStyle = createGlobalStyle`
  .title-fml {
    font-size: var(--title-font-size-fml);
    margin-bottom: var(--title-margin-bottom-fml);
  }
`;
